import { Component, ViewEncapsulation, output, input } from '@angular/core';
import { NgClass } from '@angular/common';

import { NavigationItem, NavigationType } from '../../header.model';
import { ApMenuItemComponent } from '../../menu-item/menu-item.component';

@Component({
    selector: 'ap-vertical-navigation-item',
    templateUrl: './vertical-navigation-item.component.html',
    styleUrls: ['./vertical-navigation-item.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [NgClass, ApMenuItemComponent]
})
export class ApVerticalNavigationItemComponent {
    /**
     * The navigation items
     */
    public readonly navigationItem = input<NavigationItem>();

    /**
     * Indicates whether it is the last item, which changes the styling a bit
     */
    public readonly isLastItem = input(false);

    /**
     * emits the NavigationItem that is clicked
     */
    public readonly navigationClicked = output<NavigationItem>();

    public navigationType = NavigationType;
}
